<template>
  <div class="goods_index">
    <el-breadcrumb separator="/" slot="breadcrumb" class="breadcrumb-bg">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>我的售后</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="header-top-15">
      <el-card class="box-card">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="订单号">
            <el-input v-model="formInline.oid" placeholder="订单号"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary">查询</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>

    <el-table
      :data="tableData.data"
      stripe
      style="width: 100%; margin-top: 10px"
      @selection-change="handleSelectionChange"
      ref="multipleTable"
    >
      <el-table-column prop="oid" label="订单号"> </el-table-column>

      <el-table-column prop="level" label="创建日期">
        <template slot-scope="scope">
          {{ formatGMT(scope.row.created_time) }}
        </template>
      </el-table-column>

      <el-table-column prop="totalprice" label="下单人">
        <template slot-scope="scope">
          {{ scope.row.agent_user.username }}
        </template>
      </el-table-column>
      <el-table-column prop="issue" label="问题">
        <template slot-scope="scope">
          {{ scope.row.issue }}
        </template>
      </el-table-column>
      <el-table-column prop="issue" label="描述">
        <template slot-scope="scope">
          {{ scope.row.content }}
        </template>
      </el-table-column>
      <el-table-column prop="reply" label="回复">
        <template slot-scope="scope">
          {{ scope.row.reply }}
        </template>
      </el-table-column>
      <el-table-column prop="created_time_confirm" label="回复日期">
        <template slot-scope="scope">
          <span v-if="scope.row.created_time_confirm == null"> </span>
          <span v-else>
            {{ formatGMT(scope.row.created_time_confirm) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="agent" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0"> 未处理 </span>
          <span v-if="scope.row.status == 1"> 已经处理 </span>
        </template>
      </el-table-column>
      <el-table-column prop="agent" label="状态">
        <template slot-scope="scope">
          <el-col :span="7">
            <el-button size="mini" @click="salesService(scope.row)">售后</el-button>
          </el-col>
        </template>
      </el-table-column>
    </el-table>
    <div class="header-top-15">
      <el-card class="box-card">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="tableData.totalpages"
          @current-change="changePage"
        >
        </el-pagination>
      </el-card>
    </div>

    <el-dialog title="售后服务" :visible.sync="dialogFormVisible">
      <div class="title1">订单号:{{ form.oid }}</div>
      <el-form :model="form">
        <el-form-item label="回复">
          <el-input type="textarea" v-model="form.describe" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click.native="addSalesService()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      formInline: {
        oid: "",
      },
      form: {
        id: "",
        oid: "",
      },

      multipleSelection: [],
      dialogFormVisible: false,
      dialogStoreVisible: false,
      agent: false,
      product_stock: {},
      dialog_msg_visible: false,
      dialog_restore_visible: false,
      page: 1,
      user_id: 0,
    };
  },
  methods: {
    ...mapActions({
      getOrderServiceAction: "getOrderServiceAction",
      editOrderServiceAction: "editOrderServiceAction",
    }),
    formatGMT(gmt, long) {
      long = false === long ? false : true;
      let date = new Date(gmt);

      let m = date.getMonth() + 1,
        mm = "-" + (m < 10 ? "0" + m : m);
      let d = date.getDate(),
        dd = "-" + (d < 10 ? "0" + d : d);
      let h = date.getHours(),
        hh = " " + (h < 10 ? "0" + h : h);
      let i = date.getMinutes(),
        ii = ":" + (i < 10 ? "0" + i : i);
      let s = date.getSeconds(),
        ss = ":" + (s < 10 ? "0" + s : s);

      return date.getFullYear() + mm + dd + (long ? hh + ii + ss : "");
    },
    //售后服务
    salesService(row) {
      this.dialogFormVisible = true;
      this.form.id = row.id;

      this.form.oid = row.oid;
    },
    //回复售后服务
    addSalesService() {
      let order = {
        oid: this.form.oid,
        id: this.form.id,
        describe: this.form.describe,
      };
      this.editOrderServiceAction(order);
      this.dialogFormVisible = false;
    },
    orderDetail(row) {
      const oid = row.oid;

      this.$router.push({
        name: "order_profits_detail",
        params: {
          oid: oid,
        },
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    changePage(e) {
      this.page = e;
      this.changePageData(e);
    },
    changePageData(page) {
      this.page = page;

      this.getOrderServiceAction({ page: page });
    },
  },
  created() {
    this.getOrderServiceAction({ page: this.page });
  },
  //tableData
  computed: mapState({
    tableData: (state) => state.order_service.result,
  }),
  watch: {
    tableData(newdata) {
      if (newdata.code == 301) {
        this.page = 1;
        this.getOrderServiceAction({ page: this.page });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.dialog-footer {
  text-align: center;
  background-color: gainsboro;
  padding: 0.3rem;
}
</style>
